export const EMAIL_COMPOSER_ACTIVE_TEMPLATES = [
  {
    templateName: "Funding Shield Request",
    subject: "Funding Shield Request",
    slug: "funding-shield",
    category: "Closing",
    templateDescription:
      "Send a Funding Shield Request to a specified list of emails.",
    html: null,
    text: null,
  },
  {
    templateName: "Insurance Request",
    subject: "Insurance Request - {Opportunity.Loan_Id_Calculated__c}",
    slug: "insurance-request",
    category: "Originations",
    templateDescription:
      "Request an insurance policy for the borrower and subject property.",
    html: null,
    text: `Insurance Team,

We would like to request an insurance policy for {Opportunity.Borrower_Name__r.Name} for the {Opportunity.Loan_Purpose__c} transaction for the below list of properties. Please check both the "loss payee" and "mortgagee" clauses on the EOI. The projected closing date for the loan is {Opportunity.Estimated_Closing_Date__c}.

__List of Properties__
Property Address: {Property__c.Name}, {Property__c.City__c}, {Property__c.State__c}, {Property__c.Postal_Code__c}
Property Type: {Property__c.Property_Type__c}

__Mortgagee Clause__
{Opportunity.Funding_Entity__c} ISAOA/ATIMA
290 Post Road West, Suite 100 Westport, CT 06880

__Loan Information__
* Borrower Name: {Opportunity.Borrower_Name__r.Name}
* Guarantor Name: {Guarantor__c.Contact__r.Name}
* Loan Program: {Opportunity.Loan_Program__c}
* Loan ID: {Opportunity.Loan_Id_Calculated__c}

__Borrower Contact Information__
* Name: {Guarantor__c.Contact__r.Name}
* Email: {Guarantor__c.Contact__r.Email}
* Phone Number: {Guarantor__c.Contact__r.Phone}

__Disclaimers__
If this transaction is a refinance, the projected closing date is subject to change. Purchase transactions may also be delayed due to various circumstances. An insurance quote will be acceptable to verify costs and coverage, but an EOI and invoice will be required prior to closing.

Thank you,
Lendmarq Processing Team`,
  },
  {
    templateName: "Title Request",
    subject: "Title Request - {Opportunity.Loan_Id_Calculated__c}",
    slug: "title-request",
    category: "Originations",
    templateDescription:
      "Send a title request to the title team with full loan and property details.",
    html: null,
    text: `Title Team,

Please confirm receipt and provide E&O, Wire Instructions, and CPL with our mortgagee and loan number within 24 hours of this request.

We are the Lender, {Opportunity.Funding_Entity__c} in the above referenced loan transaction. We will need title commitment for the Subject Property showing {Opportunity.Funding_Entity__c} 290 Post Road West, Suite 100, Westport, CT 06880. It must include 24 month Chain of Title, Judgement/Lien Search on entity and guarantors for the county and state of both the property and entity, and OFAC Search.

I will also need:
1. Commitment
2. A copy of the Deed - we must have the signed version as well
3. Prelim HUD

__Loan Terms__
* Mortgagee Clause: LENDER OF RECORD 290 Post Road West, Suite 100, Westport, CT 06880
* Expected closing date: {Opportunity.Estimated_Closing_Date__c}
* Property Address: {Property__c.Name}, {Property__c.City__c}, {Property__c.State__c}, {Property__c.Postal_Code__c}
* Property Type: {Property__c.Property_Type__c}
* Loan Program: {Opportunity.Loan_Program__c}
* Transaction Type: {Opportunity.Loan_Purpose__c}
* Loan Number: {Opportunity.Loan_Id_Calculated__c}
* Total Loan Amount: {Opportunity.Final_Loan_Amount__c}
* Interest Rate: {Opportunity.Note_Rate__c}
* Borrowing Name: {Opportunity.Borrower_Name__r.Name}
* Flood Zone: {Opportunity.Flood_Zone__c}
* Guarantor (1): {Guarantor__c.Contact__r.Name}
* Guarantor (1) Contact Information: {Guarantor__c.Contact__r.Phone}

__Loan Team__
* Loan Coordinator: {Opportunity.Transaction_Coordinator__r.Name}
* Closer: {Opportunity.Closing_Analyst__r.Name}
* Legal Lender Counsel: {Opportunity.Property_Access_Contact__r.Name}

__Fees for Closing Statement / HUD Preparation__
* Origination Fee: {Opportunity.Lender_Origination_Fee__c}
* Underwriting Fee: {Opportunity.Underwriting_Fee__c}
* Loan Documents Fee: {Opportunity.Loan_Documents_Fee__c}

Once we have these items our counsel will reach out if anything further is needed.

Thank you,
Processing Team`,
  },
];
